import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import Input from '../components/forms/input.jsx';
/**
 * Higher Order Component to manage inputs that submit on blur and <enter>
 * @param {React.Component} Input text input that consumes onChange, onBlur, onKeyPress
 * @returns {React.Component} Buffered input that calls onSubmit on blur and <enter>
 */

class spriteSelectorItemInput extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleChange',
            'handleKeyPress',
            'handleFlush'
        ]);
        this.state = {
            value: null
        };
    }

    handleKeyPress (e) {
        if (e.key === 'Enter') {
            this.handleFlush();
            e.target.blur();
        }
    }
    handleFlush () {
        if (this.state.value !== null) {
            this.props.onSubmit(this.state.value);
        }
        this.setState({value: null});
    }
    handleChange (e) {
        this.setState({value: e.target.value});
    }
    render () {
        const bufferedValue = this.state.value === null ? this.props.value : this.state.value;
        return (
            <Input
                {...this.props}
                value={bufferedValue}
                onBlur={this.handleFlush}
                onChange={this.handleChange}
                onKeyPress={this.handleKeyPress}
                
                
            />
        );
    }
}

spriteSelectorItemInput.propTypes = {
    onExitEditMode: PropTypes.func,
    onSubmit: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
   

export default spriteSelectorItemInput;
